import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Button, Modal, Form, Input, Select, InputNumber, DatePicker, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { wsBaseHref } from '../AppConfig';
import { Link } from 'react-router-dom';
import { composeSelectOptions } from '../utils/ComponentUtils';

function AddTournament(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [tournamentTypes, setTournamentsTypes] = useState([]);
    const [tournamentMultipliers, settournamentMultipliers] = useState([]);
    const [leagues, setLeagues] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        fetch(wsBaseHref+"/leagues")
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setLeagues(result.payLoad);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
        fetch(wsBaseHref+"/tournaments/types")
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setTournamentsTypes(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        fetch(wsBaseHref+"/tournaments/multipliers")
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              settournamentMultipliers(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        }, [])

    function toggleModal() {
        // console.warn('arrivato a toggle!!');
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        form.resetFields();
        setIsActive(false);
    }

    function onFinish(values) {
        form.validateFields({ validateOnly: true })
        .then(async () => {
          // values.stageId = props.seasonId
          const stringDate = values.date.format('YYYY-MM-DDTHH:mm:ssZ')
          // values.date = stringDate
          const tournament = {};
          tournament.name = values.name;
          tournament.date = stringDate;
          tournament.type = {};
          tournament.multiplier = {};
          tournament.type.id = values.type;
          tournament.multiplier.id = values.split;
          tournament.playerAttendancy = values.playerAttendancy;
          tournament.turns = values.turns;
          tournament.decklist = values.decklist;
          tournament.leagueOrganizer = values.leagueOrganizer;
          tournament.place = values.place;
          tournament.externalLink = values.externalLink;
          if (values.playerAttendancy >= 8 && values.turns >= 3) {
            tournament.isDone = true;
          }
          // console.warn('values della form: ', tournament)

          const response = await fetch(`${wsBaseHref}/tournaments/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + Setting.getToken(),
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(tournament) // body data type must match "Content-Type" header
          })
          .then((data) => data.json())
          // .then(() => window.location.reload(false))

          if (response.errorMsg === "") {
              window.location.reload(false);
          } else {
              messageApi.error("You do not have the permission to create this tournament! Check the inserted infos.");
          }
        })
        .catch((errorInfo) => {
          // console.warn('errorInfo:', errorInfo);
          messageApi.error("Please compile all required fields of the form!");
          }
        )
    }

    // const linkAddStageAdvanced = "/web/seasons/"+props.seasonId+"/addstage";

    return(
            <div>
                {contextHolder}
                <Modal title="Add Tournament" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} maskClosable={false} cancelText="Cancel" okText="Add">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                    <Form.Item label="Tournament Name" name="name" rules={[{ required: true, message: 'Please insert a name!' }]}>
                        <Input placeholder="Name" />
                    </Form.Item>
                    <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Please insert a date!' }]}>
                        <DatePicker placeholder="Tournament date" format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label="Organizing League" name="leagueOrganizer" rules={[{ required: true, message: 'Please select a league!' }]}>
                        <Select placeholder="Select league">
                            {composeSelectOptions(leagues,{key: 'id', value: 'id', desc: 'leagueName'},{value: 0, desc:'LPI'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Please select a type!' }]}>
                        <Select placeholder="Select type">
                            {composeSelectOptions(tournamentTypes,{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Place" name="place">
                        <Input placeholder="Place" />
                    </Form.Item>
                    <Form.Item label="External Link" name="externalLink">
                        <Input placeholder="External Link" />
                    </Form.Item>
                    <Form.Item label="Participants" name="playerAttendancy">
                        <InputNumber min={8} max={800} placeholder='no. of Participants' />
                    </Form.Item>
                    <Form.Item label="Turns" name="turns">
                        <InputNumber min={3} max={15} placeholder='no. of turns' />
                    </Form.Item>
                    <Form.Item label="Split" name="split">
                        <Select placeholder="Select ranking split">
                            {composeSelectOptions(tournamentMultipliers,{key: 'id', value: 'id', desc: 'desc'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Decklists" name="decklist">
                        <Input placeholder="Link to decklist page" />
                    </Form.Item>
                    {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            Aggiungi
                        </Button>
                    </Form.Item> */}
                </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    Add Tournament
                </Button>
            </div>
    )
}

export default AddTournament;